export default __webpack_public_path__ + "static/media/insightIcon_active.be1b440e.svg";